import React from 'react';
import {Image} from '@/components-v2';
import {useHomeStore} from '@/pages/home/v2/store';
import {useEffect} from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './home-hot-banner.css';
import Slider from 'react-slick';
import {normalizeGamePush} from '@utils/game';

function HomeHotBanner() {
  const {hotGameList, getHotGames} = useHomeStore();
  useEffect(() => {
    getHotGames();
  }, [getHotGames]);

  if (!hotGameList?.length) {
    return <div className="h-3" />;
  }

  return (
    <div className="p-3 bg-light-grey">
      <div className="home-hot-banner swiper">
        <Slider infinite autoplay variableWidth arrows={false} dots={false}>
          {hotGameList?.map(hotgame => (
            <div
              className="live-casino-carousel-item pr-2"
              key={hotgame.gameId}
              onClick={() => {
                normalizeGamePush(hotgame.gameId, true);
              }}>
              <div className="w-full h-full rounded-lg overflow-hidden">
                <Image
                  alt="bannerImg"
                  className="w-full h-full"
                  src={hotgame.bannerImg}
                />
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}

export default HomeHotBanner;
